export const SEPARATOR = {
  newline: '\r\n',
  space: ' '
}
